// extracted by mini-css-extract-plugin
module.exports = {"TopInfo":"TopInfo_TopInfo__1G4as"};